export const sideMenu = [
  {
    name: "Books",
    icon: "home",
    mode: "home",
  },
  {
    name: "Favorites",
    icon: "love",
    mode: "favorite",
  },

  {
    name: "Notes",
    icon: "idea",
    mode: "note",
  },
  {
    name: "Highlights",
    icon: "digest",
    mode: "digest",
  },
  {
    name: "Deleted Books",
    icon: "trash",
    mode: "trash",
  },
];
